import React, { useState } from 'react';
import './Dropdown.scss';

const Dropdown = ({ options, selectedOption, setSelectedOption }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => setIsOpen(!isOpen);
    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
    };

    return (
        <div className="dropdown-casi">
            <div className="dropdown-casi-header" onClick={toggleDropdown}>
                {selectedOption || options[0]}
                <span className={`dropdown-casi-arrow ${isOpen ? "open" : ""}`}>&#9662;</span>
            </div>
            {isOpen && (
                <ul className="dropdown-casi-list">
                    {options.map((option, index) => (
                        <li
                            key={index}
                            className="dropdown-casi-item"
                            onClick={() => handleOptionClick(option)}
                        >
                            {option}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Dropdown;
